import React, { Fragment, useRef, useState, memo } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import {
    ListItemIcon,
    ListItemText,
    Tooltip,
    IconButton,
    Menu,
    MenuItem
} from '@material-ui/core';
import MoreIcon from '@material-ui/icons/MoreVert';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(() => ({}));

const MoreButton = props => {
    const {buttons} = props;
    const classes = useStyles();
    const moreRef = useRef(null);
    const [openMenu, setOpenMenu] = useState(false);

    const handleMenuOpen = () => {
        setOpenMenu(true);
    };

    const handleMenuClose = () => {
        setOpenMenu(false);
    };

    const handleButtonClick = action => {
        setOpenMenu(false);
        action();
    };

    const [t] = useTranslation();

    return (
        <Fragment> {!!buttons.length &&
            <Tooltip title={t('buttons.moreOptions')}>
                <IconButton
                    {...props}
                    onClick={handleMenuOpen}
                    ref={moreRef}
                    size='small'
                >
                    <MoreIcon />
                </IconButton>
            </Tooltip>}
            <Menu
                anchorEl={moreRef.current}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left'
                }}
                classes={{ paper: classes.menu }}
                onClose={handleMenuClose}
                open={openMenu}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left'
                }}
            >
                {buttons.map(button => <MenuItem onClick={event => handleButtonClick(button.action)}>
                    <ListItemIcon>
                        <button.icon />
                    </ListItemIcon>
                    <ListItemText primary={button.label} />
                </MenuItem>)}
            </Menu>
        </Fragment>
    );
};

MoreButton.propTypes = {
    className: PropTypes.string,
    buttons: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            icon: PropTypes.object.isRequired,
            action: PropTypes.func.isRequired,
    }).isRequired
    )
};

MoreButton.defaultProps = {
    buttons: [],
};


export default memo(MoreButton);
